<template>
    <div>
        <div class="between-center mb">
            <h4 class="title subheading is-3">
                Contacts
                <a href="#" @click.prevent="isTableSettingsModalActive = true" class="gear">
                    <o-icon pack="fa" icon="gear" size="is-small"/>
                </a>
            </h4>
            <div class="field is-grouped">
                <p v-if="isDeleteSelectedButtonVisible" class="control">
                    <a @click.prevent="detachSelected" class="button is-danger">Delete selected</a>
                </p>
                <p class="control">
                    <a @click.prevent="isSelectContactModalActive = true" class="button is-info">Add Contact</a>
                </p>
            </div>
        </div>
        <o-table
            class="project-width-table is-responsive is-responsive-hd"

            v-if="isTableVisible"
            :data="contacts"

            :bordered="table.bordered"
            :striped="table.striped"
            :narrowed="table.narrowed"
            :checkable="table.checkable"
            :mobile-cards="table.mobileCards"
            :paginated="table.paginated"
            :pagination-simple="table.paginationSimple"
            :per-page="table.perPage"
            :default-sort="[hasColumn('full_name') ? 'full_name' : 'first_name', 'asc']"
            :selected.sync="selected"
            :checked-rows="checkedRows"
            @update:checkedRows="$event => checkedRows = $event"
        >
            <template>
                <template>
                    <o-table-column
                        v-for="col in tableColumns" :key="col.field"
                        :field="col.field"
                        :label="col.field === 'actions' ? '' : col.label"
                        :sortable="col.sortable"
                        #default="{ row }"
                    >
                        <router-link v-if="col.field === 'last_editor_id'" :to="{ name: 'users.show', params: { slug: row.last_editor_id } }">
                            {{ userNameById(row.last_editor_id) }}
                        </router-link>

                        <router-link v-if="col.field === 'company_id'" :to="{ name: 'companies.show', params: { slug: row.company_id } }">
                            {{ row.company_name }}
                        </router-link>

                        <content-editable v-if="col.field === 'first_name'" :entity="row" field="first_name" :update="partialUpdateContact"/>
                        <content-editable v-if="col.field === 'last_name'" :entity="row" field="last_name" :update="partialUpdateContact"/>
                        <span v-if="col.field === 'full_name'">{{ row.full_name }}</span>
                        <span v-if="col.field === 'telephone'">{{ row.telephone }}</span>
                        <span v-if="col.field === 'mobile'">{{ row.mobile }}</span>
                        <span v-if="col.field === 'email'">{{ row.email }}</span>
                        <span v-if="col.field === 'fax'">{{ row.fax }}</span>
                        <span v-if="col.field === 'title'">{{ row.title }}</span>
                        <span v-if="col.field === 'address_1'">{{ $filters.contactAddress(row) }}</span>
                        <span v-if="col.field === 'zip'">{{ row.zip }}</span>
                        <span v-if="col.field === 'lead_owner'">{{ $filters.valueOrDefault(userNameById(row.lead_owner)) }}</span>
                        <span v-if="col.field === 'tax_id'">{{ row.tax_id }}</span>
                        <span v-if="col.field === 'formatted_licenses'" class="formatted-license" v-html="row.formatted_licenses"></span>
                        <content-editable v-if="col.field === 'role'" :entity="row" field="pivot.role" :update="updateContactRole" />
                        <!--<span v-if="col.field === 'role'">{{ (row.pivot ? row.pivot.role : '') }}</span>-->
                        <span v-if="col.field === 'created_at'">{{ $filters.datetime(row.created_at) }}</span>
                        <span v-if="col.field === 'updated_at'">{{ $filters.datetime(row.updated_at) }}</span>
                        <o-dropdown v-if="col.field === 'actions'" hoverable position="bottom-left" class="table-actions">
                          <template #trigger>
                            <button class="button">
                              <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                            </button>
                          </template>
                            <o-dropdown-item has-link><a @click="openTransmittalModal(row)">Create Transmittal</a></o-dropdown-item>
                            <o-dropdown-item has-link><a @click="openViewContactModal(row)">View</a></o-dropdown-item>
                            <o-dropdown-item has-link><a @click="openEditModal(row)">Edit</a></o-dropdown-item>
                        </o-dropdown>
                    </o-table-column>
                </template>
            </template>

            <template #empty>
              <div class="has-text-centered">
                This table is empty!
              </div>
            </template>
        </o-table>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isViewContactModalActive" has-modal-card :width="960">
            <view-contact-modal :contact="currentContact" />
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isSelectContactModalActive" has-modal-card>
            <select-contact-modal @select="handleContactSelect" />
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isEditContactModalActive" has-modal-card :width="960">
            <edit-contact-modal :item="currentContact" />
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive" has-modal-card class="table-settings-modal">
            <table-settings-modal :slug="tableName"/>
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTransmittalModalActive" has-modal-card :width="960">
            <transmittal-modal :contact="currentContact" :project="currentProject" />
        </o-modal>
    </div>
<!--        <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isContactModalActive" has-modal-card>
            <customer-modal :edit-mode="true" :contact-prop="currentContact"/>
        </o-modal>
 -->
</template>

<script>
    import Table from '../../../mixins/Table'
    import {mapActions, mapGetters} from 'vuex'
    import ViewContactModal from '../../../components/modals/ViewContact'
    import SelectContactModal from '../../../components/modals/SelectContact'
    import EditContactModal from './../../../components/modals/Contact'
    import TransmittalModal from './contacts/TransmittalModal'

    export default {
        mixins: [Table],

        components: { ViewContactModal, SelectContactModal, EditContactModal, TransmittalModal },

        data () {
            return {
                tableName: 'project-contacts',
                currentContact: null,
                isSelectContactModalActive: false,
                isViewContactModalActive: false,
                isEditContactModalActive: false,
                isTransmittalModalActive: false,
            }
        },

        created() {
          this.fetchContacts({ project_id:  parseInt(this.$route.params.slug)})
        },

      methods: {
            ...mapActions(['attachProjectContact', 'detachProjectContact', 'partialUpdateContact', 'fetchContacts']),

            ...mapActions({
                removeItem: 'removeContact',
            }),

            updateContactRole(payload) {
                return this.attachProjectContact({
                    project_id: this.projectId,
                    contact_id: payload.id,
                    role: payload['pivot.role']
                })
            },

            openViewContactModal(contact) {
                this.currentContact = contact
                this.isViewContactModalActive = true
            },

            openEditModal(contact) {
                this.currentContact = contact
                this.isEditContactModalActive = true
            },

            handleContactSelect(contact, role) {
                this.attachProjectContact({
                    project_id: this.projectId,
                    contact_id: contact.id,
                    role: role
                }).then(res => {
                    this.isSelectContactModalActive = false
                    this.successMessage('Contact has been successfull added')
                    this.fetchContacts({ project_id:  parseInt(this.$route.params.slug)})
                    this.contactsByProjectId(parseInt(this.$route.params.slug))
                    return res
                })
            },

            detachSelected() {
                this.confirmMessage(
                    'Are you sure?',
                    'Detached contacts will not receive any project notifications.',
                    'Yes'
                ).then(() => {
                    if (this.checkedRows.length) {
                        let promises = []

                        this.checkedRows.forEach(item => {
                            promises.push(this.detachProjectContact({
                                project_id: this.projectId,
                                contact_id: item.id
                            }))
                        })

                        Promise.all(promises).then(() => {
                            this.successMessage('Deletion successfull')
                            this.checkedRows = []
                          this.fetchContacts({ project_id:  parseInt(this.$route.params.slug)})
                          this.contactsByProjectId(parseInt(this.$route.params.slug))
                        })
                    }
                })
            },

            openTransmittalModal(contact) {
                this.currentContact = contact
                this.isTransmittalModalActive = true
            }
        },

        computed: {
            ...mapGetters([
                'userNameById',
                'currentProject',
                'contactsByProjectId',
            ]),

            projectId() {
                return parseInt(this.$route.params.slug)
            },

            contacts() {
              return this.contactsByProjectId(this.projectId)
                // return this.currentProject.contacts.map(i => {
                //     i.pivot = {role: i.role}
                //     return i
                // })
            },

            roles() {
                return this.contacts
            }
        }
    }
</script>
